module.exports = __webpack_public_path__ + "img/book.6bc62b6a.png";